var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoins(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 68.75C49.925 68.75 62.5 64.4562 62.5 56.25V18.75C62.5 10.5438 49.925 6.25 37.5 6.25C25.075 6.25 12.5 10.5438 12.5 18.75V56.25C12.5 64.4562 25.075 68.75 37.5 68.75ZM37.5 62.5C25.8688 62.5 18.75 58.4531 18.75 56.25V52.2875C23.5656 54.9062 30.5531 56.25 37.5 56.25C44.4469 56.25 51.4344 54.9062 56.25 52.2875V56.25C56.25 58.4531 49.1312 62.5 37.5 62.5ZM37.5 12.5C49.1312 12.5 56.25 16.5469 56.25 18.75C56.25 20.9531 49.1312 25 37.5 25C25.8688 25 18.75 20.9531 18.75 18.75C18.75 16.5469 25.8688 12.5 37.5 12.5ZM18.75 27.2875C23.5656 29.9063 30.5531 31.25 37.5 31.25C44.4469 31.25 51.4344 29.9063 56.25 27.2875V31.25C56.25 33.4531 49.1312 37.5 37.5 37.5C25.8688 37.5 18.75 33.4531 18.75 31.25V27.2875ZM18.75 39.7875C23.5656 42.4062 30.5531 43.75 37.5 43.75C44.4469 43.75 51.4344 42.4062 56.25 39.7875V43.75C56.25 45.9531 49.1312 50 37.5 50C25.8688 50 18.75 45.9531 18.75 43.75V39.7875Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/Coins.96e8c8bf.svg";
export { ForwardRef as ReactComponent };